/* Product dropdowns (Andrés 2026-10-30): one open at a time to save space. Every row is <details name="op-props">, which
   modern browsers already treat as an exclusive group; this closes the others for browsers without that support.
   On phones, opening a lower row closes a long one above it and the page can shift: the opened row is then brought back
   into view (QA 2026-10-30). Reduced motion gets an instant scroll. */
(() => {
  const phone = window.matchMedia('(max-width: 749px)');
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open || d.getAttribute('name') !== 'op-props') return;
    document.querySelectorAll('details[name="op-props"][open]').forEach((o) => { if (o !== d) o.open = false; });
    if (!phone.matches) return;
    const summary = d.querySelector('summary');
    requestAnimationFrame(() => {
      const top = summary.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) {
        summary.scrollIntoView({ block: 'start', behavior: calm.matches ? 'auto' : 'smooth' });
      }
    });
  }, true);
})();

/* Fixed «Agregar al carrito» bar on phones (snippets/oparina-sticky-atc.liquid). Shown only while the real button is out of
   view; its click is the real button's click, so Sense's product form adds the selected variant and quantity. Label, disabled
   state, loading and price follow the real button and the price block (they change with the variant). */
(() => {
  const bar = document.querySelector('[data-op-sticky]');
  const real = document.querySelector('.product__info-container .product-form__submit');
  if (!bar || !real || !('IntersectionObserver' in window)) { if (bar) bar.remove(); return; }
  document.body.appendChild(bar);
  const btn = bar.querySelector('[data-op-sticky-btn]');
  const priceOut = bar.querySelector('[data-op-sticky-price]');
  const priceBox = document.querySelector('.product__info-container [id^="price-"]');
  const phone = window.matchMedia('(max-width: 749px)');
  let realVisible = true;

  const sync = () => {
    const label = (real.querySelector('span') || real).textContent.trim();
    if (label) btn.textContent = label;
    btn.disabled = real.disabled || real.getAttribute('aria-disabled') === 'true';
    btn.setAttribute('aria-busy', real.classList.contains('loading') ? 'true' : 'false');
    const price = priceBox && priceBox.querySelector('.price');
    if (price) {
      const item = price.classList.contains('price--on-sale')
        ? price.querySelector('.price__sale .price-item--sale') : price.querySelector('.price__regular .price-item--regular');
      priceOut.textContent = item ? item.textContent.trim() : '';
    }
  };
  const show = () => {
    const on = phone.matches && !realVisible;
    bar.hidden = !phone.matches;
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    btn.tabIndex = on ? 0 : -1;
    document.body.classList.toggle('op-sticky-on', on);
  };

  new IntersectionObserver((entries) => { realVisible = entries[0].isIntersecting; show(); }).observe(real);
  new MutationObserver(sync).observe(real, { attributes: true, childList: true, subtree: true, characterData: true });
  if (priceBox) new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true, characterData: true });
  phone.addEventListener('change', show);
  btn.addEventListener('click', () => { if (!btn.disabled) real.click(); });
  sync(); show();
})();

